import {
	SET_CURRENT_WIDGET_ID,
	RESET_CURRENT_WIDGET_ID
} from "../../actions/DashboardDesigner/actionContants";

const currentWidgetId = (state = null, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_CURRENT_WIDGET_ID:
			return payload;
		case RESET_CURRENT_WIDGET_ID:
			return null;
		default:
			return state;
	}
};

export default currentWidgetId;
